import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./requests.css";

import { DataTable, TableColumn } from "@shared/Table/DataTable";
import { Pagination } from "@shared/Table/Pagination";
import { Search } from "@shared/Search";

// import { requests } from './data';

// import notification from "../../assets/images/notifications.png";
import {
  getAllPropertyTransactions,
  // respondToHostRequest,
  // acceptTransaction,
} from "@services/krent.service";
import { useSessionStorage } from "../../hooks";
import ktoast from "@services/toast.service";
import { differenceInDays } from "date-fns";
// import DevTable from "@shared/Table/Dev/Table";
// import { recent_requests_data } from "@utils/constants";
// import { NotificationsInterfaceResponse } from "@interfaces/notifications.interface";
// import {
//   AgentRequestAction,
//   completedInspection,
//   getAgentRequest,
//   getComments,
// } from "@services/krentDeveloper";
// import { Modal } from "react-bootstrap";
// import UploadReceipt from "components/UsersDashboard/uploadReceipt";
// import { toast } from "react-toastify";
// import { formatDateToTime } from "@utils/helpers";

// interface Request {
//   requestDate: string;
//   interestID: string;
//   propertyName: string;
//   status: string;
//   clientName: string;
// }
// const steps = [
//   "Request accepted",
//   "Inspection confirmed",
//   "Payment made",
//   "Documentation process",
//   "Documentation received",
// ];

export const Requests = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState<string>("shortlet");
  const [intent, setIntent] = useState<string>("shortlet");
  const [search, setSearch] = useState<string>("");
  const [user] = useSessionStorage("user", {});
  const [loading, setLoading] = useState<boolean>(false);
  const [transactions, setTransactions] = useState<any[]>([]);
  // const [requests, setRequests] = useState<NotificationsInterfaceResponse[]>(
  //   [],
  // );
  // const [pendingModal, setPendingModal] = useState(false);
  // const [acceptedModal, setAcceptedModal] = useState(false);
  // const [selectedRequest, setSelectedRequest] = useState<Request | null>(null);
  // const [isLoading, setIsLoading] = useState(false);
  // const [showProceedtoUploadDoc, setShowProceedtoUploadDoc] = useState(false);
  // const [isAgentUpload, setIsAgentUpload] = useState(false);
  // const [purchaseUpdate, setPurchaseUpdate] = useState(false);
  // const [questionModal, setQuestionModal] = useState(false);
  // const [devComments, setDevComments] = useState([]);
  const [page, setPage] = useState<number>(1);
  const [pagination, setPagination] = useState({ last_page: 1 });
  // const [devRequestsLoading, setDevRequestsLoading] = useState(false);
  // const [hostResponseModal, setHostResponseModal] = useState(false);
  // const [selectedTransaction, setSelectedTransaction] = useState<any>(null);
  // const [isResponding, setIsResponding] = useState(false);

  // const handleHostResponse = async (action: "accept" | "decline") => {
  //   if (!selectedTransaction) return;

  //   setIsResponding(true);
  //   try {
  //     await respondToHostRequest(selectedTransaction.id, action);
  //     ktoast.success(`Request ${action}ed successfully`);

  //     // Update the transaction status in the local state
  //     setTransactions((prevTransactions) =>
  //       prevTransactions.map((transaction) =>
  //         transaction.id === selectedTransaction.id
  //           ? {
  //               ...transaction,
  //               status: action === "accept" ? "Accepted" : "Rejected",
  //             }
  //           : transaction,
  //       ),
  //     );

  //     setHostResponseModal(false);
  //     setSelectedTransaction(null);
  //   } catch (error: any) {
  //     console.error("Failed to respond to host request:", error);
  //     ktoast.error(error.message || "Failed to respond to request");
  //   } finally {
  //     setIsResponding(false);
  //   }
  // };

  // const handleAction = (action: any) => {
  //   setIsLoading(true);
  //   const abortController = new AbortController();
  //   if (selectedRequest) {
  //     AgentRequestAction(
  //       action,
  //       selectedRequest.interestID,
  //       abortController.signal,
  //     )
  //       .then((res) => {
  //         console.log(res);
  //         ktoast.success(`Request ${action}ed successfully`);
  //         setRequests((prevRequests) =>
  //           prevRequests.map((req) =>
  //             req.id === selectedRequest.interestID
  //               ? {
  //                   ...req,
  //                   status: action === "accept" ? "Accepted" : "Rejected",
  //                 }
  //               : req,
  //           ),
  //         );
  //         setPendingModal(false);
  //         setTransactions((prevTransactions) =>
  //           prevTransactions.map((transaction) =>
  //             transaction.id === selectedRequest.interestID
  //               ? {
  //                   ...transaction,
  //                   status: action === "accept" ? "Accepted" : "Rejected",
  //                 }
  //               : transaction,
  //           ),
  //         );
  //       })
  //       .catch((err) => {
  //         ktoast.error(`Failed to ${action} request: ${err || err.message}`);
  //       })
  //       .finally(() => {
  //         setIsLoading(false);
  //       });
  //   }
  //   return () => {
  //     abortController.abort();
  //   };
  // };
  const tabList: string[] = ["shortlet", "rent", "sale"];

  const getColumns = (): TableColumn<any>[] => {
    const baseColumns: TableColumn<any>[] = [
      {
        key: "property",
        header: "PROPERTY",
        render: (request) => request?.listing?.title,
      },
      {
        key: "cost",
        header: intent === "long lease" ? "COST PER ANNUM" : "COST PER NIGHT",
        render: (request) =>
          `₦${request?.listing?.price?.toLocaleString()}${intent !== "sale" && intent !== "iBuying" ? " / night" : ""}`,
      },
      {
        key: "requestFrom",
        header: "REQUEST FROM",
        render: (request) =>
          request?.renter?.name ||
          request?.renter?.prefferedName ||
          `${request?.renter?.firstname} ${request?.renter?.lastname}`,
      },
      {
        key: "dateOfRequest",
        header: "DATE OF REQUEST",
        render: (request) =>
          new Date(request?.createdAt).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
          }),
      },
      {
        key: "status",
        header: "STATUS",
        render: (request) => {
          const formatStatus = (status: string) => {
            if (status === "timeout_unconfirmed") return "timeout";
            if (status === "pending_payment") return "pending payment";
            return status;
          };

          const getStatusColor = (status: string) => {
            if (status === "confirmed" || status === "Accepted")
              return "#1B9E78";
            if (
              status === "failed" ||
              status === "cancelled" ||
              status === "Rejected"
            )
              return "#DC2626";
            return "#92400e";
          };

          const getStatusBgColor = (status: string) => {
            if (status === "confirmed" || status === "Accepted")
              return "#e6f7f1";
            if (
              status === "failed" ||
              status === "cancelled" ||
              status === "Rejected"
            )
              return "#FEE2E2";
            return "#fef3c7";
          };

          const formattedStatus = formatStatus(request?.status);

          return (
            <span
              className="badge"
              style={{
                backgroundColor: getStatusBgColor(request?.status),
                color: getStatusColor(request?.status),
                fontWeight: 500,
                fontSize: 12,
                borderRadius: 20,
                padding: "4px 12px",
              }}
            >
              {formattedStatus}
            </span>
          );
        },
      },
      {
        key: "actions",
        header: "ACTIONS",
        render: (request) => (
          <div className="dropdown">
            <button
              className="btn btn-link p-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{
                color: "#9ca3af",
                textDecoration: "none",
                fontSize: "20px",
              }}
            >
              ⋮
            </button>
            <ul className="dropdown-menu fs-14 border-round px-3">
              <li>
                <span
                  className="dropdown-item cursor-pointer"
                  onClick={() => navigate(`/requests/${request.id}`)}
                >
                  View request
                </span>
              </li>
            </ul>
          </div>
        ),
      },
    ];

    if (intent !== "sale" && intent !== "iBuying") {
      baseColumns.splice(5, 0, {
        key: "stayDuration",
        header: "STAY DURATION",
        render: (request) => {
          const stayDuration = differenceInDays(
            new Date(request?.departure_date),
            new Date(request?.arrival_date),
          );
          return `${stayDuration} nights`;
        },
      });
    }

    return baseColumns;
  };

  // const filterRequests = (requests: any[], tab: string) => {
  // 	return requests.filter((request: any) => request.type === tab);
  // };

  const filteredTransaction = transactions?.filter(
    (transaction) => transaction?.listing?.intent === intent,
  );
  // const handleInspectionCompleted = async () => {
  //   if (!selectedRequest) return {};
  //   setIsLoading(true);
  //   try {
  //     const abortController = new AbortController();
  //     const res = await completedInspection(
  //       selectedRequest.interestID,
  //       abortController.signal,
  //     );
  //     toast.success(res.message);
  //     setTimeout(() => {
  //       setQuestionModal(false);
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Error completing inspection:", err);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const fetchComments = async (itemId: string) => {
  //   const abortController = new AbortController();
  //   try {
  //     const response = await getComments(itemId, abortController.signal);
  //     setDevComments(response.data);
  //   } catch (error) {
  //     console.error("Error fetching comments:", error);
  //   }
  // };

  // useEffect(() => {
  //   if (selectedRequest?.interestID) {
  //     fetchComments(selectedRequest.interestID);
  //   }

  // }, [selectedRequest]);
  useEffect(() => {
    const abortController = new AbortController();
    setLoading(true);

    getAllPropertyTransactions(user?.id, abortController.signal, page, intent)
      .then((resp: any) => {
        setTransactions(resp.data);
        setPagination(resp.pagination || { last_page: 1 });
      })
      .catch(() => {
        ktoast.error("Failed to load Transasctions");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [user, page, intent]);

  // useEffect(() => {
  //   setDevRequestsLoading(true);
  //   const abortController = new AbortController();

  //   if (user?.role === "agent") {
  //     getAgentRequest(abortController.signal)
  //       .then((res) => {
  //         setRequests(res);
  //       })
  //       .catch((err) => {
  //         if (err.name !== "AbortError") {
  //           console.log(err);
  //         }
  //       })
  //       .finally(() => {
  //         setDevRequestsLoading(false);
  //       });
  //   } else {
  //     setDevRequestsLoading(false);
  //   }

  //   return () => {
  //     abortController.abort();
  //   };
  // }, [user?.role]);

  // const renderStatusCell = (cell: any) => {
  //   if (cell.column.id === "action") {
  //     const status = cell.row.original.status;
  //     const isRejected = status === "Rejected";

  //     const handleActionButtonClick = (e: any) => {
  //       e.preventDefault();
  //       setSelectedRequest(cell.row.original);

  //       const pendingStatuses = ["Interest", "Pending"];
  //       const acceptedStatuses = [
  //         "Accepted",
  //         "Inspection Booked",
  //         "Inspection Completed",
  //       ];

  //       if (status === "pending_host_confirmation") {
  //         setSelectedTransaction(cell.row.original);
  //         setHostResponseModal(true);
  //       } else if (pendingStatuses.includes(status)) {
  //         setPendingModal(true);
  //       } else if (acceptedStatuses.includes(status)) {
  //         setAcceptedModal(true);
  //       } else if (status === "Purchase-Request") {
  //         setIsAgentUpload(true);
  //         setShowProceedtoUploadDoc(true);
  //       }
  //     };

  //     return (
  //       <div className="flex items-center justify-between">
  //         <button
  //           className={`rounded-10 p-2 border-green text-primary fs-12 fw-bold border-green bg-white  ${
  //             isRejected ? "opacity-50 light-text cursor-not-allowed" : ""
  //           }`}
  //           onClick={handleActionButtonClick}
  //           disabled={isRejected}
  //         >
  //           View details
  //         </button>
  //       </div>
  //     );
  //   }
  //   if (cell.column.id === "status") {
  //     const isCompleted = cell.value === "Accepted";
  //     const isRejected = cell.value === "Rejected";

  //     return (
  //       <div className="flex items-center justify-between ">
  //         <span
  //           className={`rounded-10 p-2 fs-12 ${
  //             isRejected ? "previous " : isCompleted ? "current " : "future "
  //           } `}
  //         >
  //           {cell.value === "Interest" ||
  //           cell.value === "Purchase-request" ||
  //           cell.value === "Pending"
  //             ? "Pending"
  //             : cell.value}
  //         </span>
  //       </div>
  //     );
  //   }
  //   if (cell.column.id === "details") {
  //     return (
  //       <div className="flex items-center justify-between">
  //         <button
  //           className="text-black border rounded-10 bg-white flex items-center fs-12 fw-bold"
  //           onClick={() => {
  //             setSelectedRequest(cell.row.original);
  //             setPurchaseUpdate(true);
  //           }}
  //         >
  //           <span>View purchase update</span>&nbsp;
  //           <i className="fa fa-arrow-up-right mr-2" />
  //         </button>
  //       </div>
  //     );
  //   }
  //   return cell.render("Cell");
  // };
  // const getCurrentStep = (selectedRequest: any) => {
  //   if (!selectedRequest?.status) return 0;

  //   if (selectedRequest.status === "Inspection Booked") return 1;

  //   if (selectedRequest.status === "Inspection Completed") return 2;

  //   if (selectedRequest.status === "confirmed" || "Purchase-Request") return 3;

  //   if (selectedRequest.status === "Documentation process") return 4;
  //   if (selectedRequest.status === "Doc completed") return 5;

  //   return 0;
  // };
  return (
    <div>
      {/* Tab bar */}
      <div className="tab-bar">
        <div className="tabs">
          {tabList.map((tabItem) => (
            <button
              key={tabItem}
              className={`tab-btn capitalize ${tab === tabItem ? "active" : ""}`}
              onClick={() => {
                setTab(tabItem);
                setIntent(
                  tabItem === "shortlet"
                    ? "shortlet"
                    : tabItem === "rent"
                      ? "long lease"
                      : tabItem === "sale"
                        ? "sale"
                        : "iBuying",
                );
              }}
            >
              {tabItem === "iBuying" ? "i Buying" : tabItem}
              {tab === tabItem && <span className="tab-underline" />}
            </button>
          ))}
        </div>
      </div>

      {/* Search + filter */}
      <Search
        placeholder="Search requests..."
        value={search}
        onChange={setSearch}
        showFilter={true}
      />

      {/* Table */}
      <div style={{ overflowX: "auto" }}>
        <DataTable
          columns={getColumns()}
          data={filteredTransaction}
          loading={loading}
          rowKey={(request) => request.id}
        />
      </div>

      {/* Pagination */}
      <Pagination
        currentPage={page}
        totalPages={pagination.last_page}
        onPageChange={setPage}
      />

      {/* <div className="mt-4 hidden">
        <h5 className="py-2">Developer Project Requests</h5>
        <p className="fs-14">
          Manage all developer property requests on your property
        </p>
        {devRequestsLoading ? (
          <div>Loading...</div>
        ) : (
          <DevTable
            columnData={recent_requests_data}
            rowData={requests}
            label="sold properties"
            totalDocs={requests?.length}
            renderCell={renderStatusCell}
            loading={devRequestsLoading}
          />
        )}

        <Modal show={pendingModal} onHide={() => setPendingModal(false)}>
          <div className="container p-4">
            <p className="fw-bold ">Someone has made a request for an agent</p>
            <p className="py-2">
              You have been selected to be an agent for this property: Which
              means an interest has been made for the property
            </p>
            <p>Please take prompt action by accepting or rejecting</p>
            <div className="w-full flex justify-between my-4 gap-4">
              <button
                onClick={() => handleAction("accept")}
                className="btn btn-primary rounded-pill py-2 text-white fw-bold w-full"
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Accept"}
              </button>
              <button
                onClick={() => handleAction("reject")}
                className="btn border-red text-red bg-white rounded-pill py-2 fw-bold w-full"
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Reject"}
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          show={purchaseUpdate}
          onHide={() => setPurchaseUpdate(false)}
          size="lg"
        >
          <div className="container p-4">
            <div className="flex justify-between items-center">
              <p className="fw-bold ">Purchase update</p>
              <button
                className="fw-bold bg-white"
                onClick={() => setPurchaseUpdate(false)}
              >
                X
              </button>
            </div>
            <hr />
            <div>
              <div
                className="stepper-container"
                style={
                  {
                    "--total-steps": 5,
                    "--current-step": getCurrentStep(selectedRequest),
                  } as React.CSSProperties
                }
              >
                {Array.from({ length: 5 }, (_, index) => (
                  <div key={index} className="w-full">
                    <div
                      className={`step-item ${
                        index < getCurrentStep(selectedRequest) ? "active" : ""
                      }`}
                    >
                      <div className="step-number">{index + 1}</div>
                      {index < 4 && <div className="step-line"></div>}
                    </div>
                    <div className="mt-2 fs-12">{steps[index]}</div>
                  </div>
                ))}
              </div>
            </div>
            <hr />
            <div>
              {devComments.length > 0 && (
                <>
                  <hr />
                  <div>
                    <h6 className="pb-2">Developer comments</h6>
                    {devComments.map((comment: any, idx: any) => (
                      <div key={idx} className="w-15">
                        <div className="border p-2 rounded-10">
                          <p>{comment.content}</p>
                        </div>
                        <p className="fs-10 py-2 w-max ml-auto">
                          {formatDateToTime(comment.timestamp)}
                        </p>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal>
        <Modal
          show={acceptedModal}
          onHide={() => setAcceptedModal(false)}
          size="sm"
        >
          <div className="container py-3">
            <p className="fw-bold ">
              You have accepted the request for an agent
            </p>
            <p>
              You have accepted to be an agent for this property:{" "}
              <span className="text-primary capitalize">
                {selectedRequest?.propertyName}
              </span>{" "}
              <span className="fw-bold">for {selectedRequest?.clientName}</span>
              .
            </p>
            <p className="my-2">
              Has the inspection been carried out yet? Click to upload proof of
              payment
            </p>
            <div className="text-center my-4">
              {selectedRequest?.status === "Inspection Booked" ? (
                <button
                  className="bg-primary rounded-10 text-white p-2 h-max"
                  onClick={() => {
                    setQuestionModal(true);
                  }}
                  disabled={isLoading}
                >
                  Inspection completed?
                </button>
              ) : (
                <button
                  className="bg-black rounded-10 text-white p-2 h-max"
                  onClick={() => {
                    setAcceptedModal(false);
                    setIsAgentUpload(true);
                    setShowProceedtoUploadDoc(true);
                  }}
                >
                  Proceed to upload documents
                </button>
              )}
            </div>
          </div>
        </Modal>
        <UploadReceipt
          show={showProceedtoUploadDoc}
          onClose={() => {
            setIsAgentUpload(false);
            setShowProceedtoUploadDoc(false);
          }}
          propertyId={selectedRequest?.interestID}
          item={selectedRequest}
          isAgentUpload={isAgentUpload}
        ></UploadReceipt>
        <Modal
          show={questionModal}
          onClose={() => setQuestionModal(false)}
          dismissible={false}
        >
          <div className="p-4">
            <div className="flex justify-between gap-2">
              <h5 className="w-full no-text-wrap">
                Has Inspection been completed?
              </h5>
              <button
                onClick={() => setQuestionModal(false)}
                className="bg-white"
              >
                <i className="fa-regular fa-x"></i>
              </button>
            </div>
            <div className="flex gap-2 my-4">
              <button
                onClick={handleInspectionCompleted}
                className="bg-primary rounded-10 p-2 w-full text-white"
              >
                Yes
              </button>
              <button
                onClick={() => setQuestionModal(false)}
                className="border-red text-red bg-white rounded-10 p-2 w-full"
              >
                No
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          show={hostResponseModal}
          onClose={() => {
            setHostResponseModal(false);
            setSelectedTransaction(null);
          }}
          dismissible={false}
        >
          <div className="p-4">
            <div className="flex justify-between gap-2 mb-4">
              <h5 className="w-full no-text-wrap">
                Respond to Booking Request
              </h5>
              <button
                onClick={() => {
                  setHostResponseModal(false);
                  setSelectedTransaction(null);
                }}
                className="bg-white"
                disabled={isResponding}
              >
                <i className="fa-regular fa-x"></i>
              </button>
            </div>

            <div className="mb-4">
              <p className="text-muted">
                You have a booking request that requires your response. Please
                choose to accept or decline this request.
              </p>
              {selectedTransaction && (
                <div className="bg-light p-3 rounded">
                  <small className="d-block">
                    <strong>Property:</strong>{" "}
                    {selectedTransaction.propertyName || "N/A"}
                  </small>
                  <small className="d-block">
                    <strong>Guest:</strong>{" "}
                    {selectedTransaction.guestName || "N/A"}
                  </small>
                  <small className="d-block">
                    <strong> Dates:</strong>{" "}
                    {selectedTransaction.dateFrom && selectedTransaction.dateTo
                      ? `${new Date(selectedTransaction.dateFrom).toLocaleDateString()} - ${new Date(selectedTransaction.dateTo).toLocaleDateString()}`
                      : "N/A"}
                  </small>
                </div>
              )}
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => handleHostResponse("accept")}
                disabled={isResponding}
                className="bg-success text-white rounded-10 p-2 w-full d-flex align-items-center justify-content-center gap-2"
              >
                {isResponding ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Accepting...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-check"></i>
                    Accept
                  </>
                )}
              </button>
              <button
                onClick={() => handleHostResponse("decline")}
                disabled={isResponding}
                className="bg-danger text-white rounded-10 p-2 w-full d-flex align-items-center justify-content-center gap-2"
              >
                {isResponding ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Declining...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-times"></i>
                    Decline
                  </>
                )}
              </button>
            </div>
          </div>
        </Modal>
      </div> */}
    </div>
  );
};
